import { StateKey } from 'common/utils/flipState'
import { Sort } from 'common/constants'
import { CommonState } from 'common/types'

export interface MapSort {
  sort: Sort
}

const initialState: MapSort = {
  sort: Sort.MAP_POPULARITY,
}

const SET = 'map/sort/SET'

export const initMapSort = (curState: StateKey, queryParams?: any) => {
  const sort = queryParams && queryParams.sort && Sort[queryParams.sort] ? queryParams.sort : initialState.sort
  return {
    curState,
    sort,
    type: SET,
  }
}

export const setMapSort = (curState: StateKey, sort: Sort) => (dispatch, getState: () => CommonState) => {
  const mapSort = getState().mapSort[curState]
  if (mapSort.sort === sort) return
  dispatch({
    curState,
    sort,
    type: SET,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET:
      return {
        sort: action.sort,
      }
    default:
      return state
  }
}

export default reducer
